import { render } from "./living_expenses.vue?vue&type=template&id=440baabd"
import script from "./living_expenses.vue?vue&type=script&lang=js"
export * from "./living_expenses.vue?vue&type=script&lang=js"

import "./living_expenses.vue?vue&type=style&index=0&id=440baabd&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__